import { Config } from "./config.js";
import { handleTopnavLinks as navbar } from "./navbarhelper.js";
import "./cookiebar.js";

import {
  navBarRecolorator,
  hideNavbarOnScroll,
  disableScrollAnimation,
} from "./navbarhelper.js";
import { addSwiper, addImageLinkHandling } from "./myswiper.js";
import { animateWhenVisible } from "./myanimation.js";
import { initPolishToggle } from "./polishToggle.js";

const ASSET_VERSION = "1.0.12-js-build-cleanup";

const config = Config();
window.config = config;
window.myConfig = config;
initPolishToggle();

if (config.website.scrollToTopOnReload) {
  window.onbeforeunload = function () {
    window.history.scrollRestoration = "manual";
  };
} else {
  window.history.scrollRestoration = "auto";
}

// Do we have an anchor in the URL?

const anchorHash = window.location.hash;
if (anchorHash) {
  disableScrollAnimation(1000, config);
}

const scrollDownOnClick = function () {
  const selector = document.querySelectorAll(".scroll-down-on-click");
  // scroll down exactly 1 viewport height
  selector.forEach((el) => {
    el.addEventListener("click", function () {
      window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: "smooth",
      });
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.querySelector(".menu-toggle");
  const body = document.querySelector("body");

  if (!menuToggle || !body) return;

  menuToggle.addEventListener("click", function () {
    this.classList.toggle("open");
    document.querySelector(".mobile-nav")?.classList.toggle("open");
    body.classList.toggle("menu-is-open");
  });
});

document.addEventListener("DOMContentLoaded", function () {
  console.info(`Pittroff assets ${ASSET_VERSION}`);
  scrollDownOnClick();
  navbar(config);
  addSwiper();
  addImageLinkHandling();
  navBarRecolorator();
  animateWhenVisible();
  hideNavbarOnScroll(config);
});
